module.exports = __webpack_public_path__ + "img/notify_icon.3be7fce9.svg";